var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOneMarket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299,
    height: 164,
    viewBox: "0 0 299 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3310_35193)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3310_35193",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 299,
    height: 164
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M298.917 0H0.0830078V164H298.917V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3310_35193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.3687 105.668L76.3002 9.08447H228.153L222.221 105.668H70.3687Z",
    fill: "#EDE9FA",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1064 9.08443L76.6218 -0.00012207H228.631L228.116 9.08443H76.1064Z",
    fill: "#1E293B",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7607 158.997C80.3025 160.425 80.6352 161.927 80.7463 163.444C87.4553 163.117 94.1643 163.362 100.873 163.034C101.025 162.456 100.705 161.838 100.228 161.456C99.7501 161.074 99.1404 160.884 98.5409 160.725C96.8923 160.29 95.184 159.45 93.618 158.792C92.052 158.133 90.5954 156.992 90.1063 155.421C86.7057 155.925 83.3642 156.795 79.7614 158.997H79.7607Z",
    fill: "white",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2869 138.337C70.706 144.972 74.5124 153.074 78.042 160.47C82.9628 159.217 87.7367 157.434 92.1917 155.245C88.2152 147.427 84.2785 138.485 80.2116 130.71C77.3518 125.242 74.4343 119.733 70.3541 115.031C67.2756 118.133 64.0599 121.482 63.2348 125.69C62.8079 127.866 63.0642 130.114 63.4946 132.29C64.0339 135.017 64.8443 137.695 66.2869 138.337Z",
    fill: "#2473BD",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0438 122.723C20.0498 130.48 17.415 151.487 15.9316 163.062",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8105 121.6C48.2934 136.354 51.9422 149.069 55.7559 163.747",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8276 98.527C70.7807 99.0012 72.9525 98.4889 74.4875 97.2465C74.9021 96.9108 75.5054 96.9024 75.934 97.2212L76.6611 98.1006C76.8945 98.2742 77.4187 98.8819 77.8537 98.3783C77.9528 98.1431 77.809 97.8835 77.6698 97.6675C77.2711 97.0476 77.071 96.4278 76.6723 95.8076C77.0844 96.3688 77.2971 96.9297 77.7092 97.4909C77.9989 97.8856 78.3694 98.3224 78.8729 98.3173C78.9731 98.3163 79.0793 98.2934 79.1496 98.225C79.2484 98.1279 79.246 97.9745 79.2319 97.8397C79.1261 96.8363 78.6226 96.0543 78.1581 95.3333C78.6964 96.2879 79.3898 97.023 80.0356 97.9142C80.1334 98.049 80.2529 98.1953 80.4231 98.2125C80.6154 98.2321 80.7852 98.0652 80.8281 97.8845C80.871 97.7039 80.8193 97.5158 80.7634 97.3385C80.4874 96.4628 80.0968 95.6198 79.6042 94.8362C80.0866 95.8248 80.7237 96.7436 81.4881 97.5522C81.6572 97.7312 81.8446 97.9122 82.0872 97.9779C82.3298 98.0436 82.6378 97.9469 82.7126 97.7164C82.7439 97.6203 82.7309 97.5195 82.7024 97.4211C82.6188 97.1322 82.4964 96.8558 82.3695 96.5818C82.0334 95.8551 81.7124 95.0499 81.0992 94.4833C80.331 93.7731 79.2231 93.5371 78.1704 93.3693C75.1854 92.894 72.1467 92.7309 69.1251 92.8832C68.6698 94.4576 68.2169 96.1544 68.8276 98.527Z",
    fill: "white",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.15 119.059C25.9607 119.043 25.3475 118.909 23.1785 119.195C21.9156 119.361 20.491 119.655 20.3816 120.872C20.3088 121.682 20.5753 122.131 21.3573 122.445C22.1392 122.758 23.0154 122.743 23.8624 122.723C34.5345 122.474 43.7209 122.597 54.3931 122.348C55.0235 122.334 55.6704 122.316 56.2534 122.085C56.8363 121.855 57.3503 121.362 57.4017 120.76C57.4555 120.128 56.9843 119.54 56.4014 119.24C55.8185 118.941 55.1423 118.789 54.4817 118.817C49.179 119.039 34.2434 119.102 28.1504 119.059L28.15 119.059Z",
    fill: "white",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4673 119.022C45.7377 118.964 46.0281 119.053 46.2461 119.216C46.464 119.38 46.617 119.613 46.7263 119.857C46.8715 120.182 46.9457 120.536 46.9482 120.89C46.951 121.257 46.8733 121.633 46.6652 121.941C46.457 122.249 46.1061 122.48 45.7236 122.496",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6877 62.0663C33.1708 60.8401 32.7401 59.4511 32.0844 58.3007C31.4284 57.1506 30.5487 56.1138 30.0406 54.8967C28.8143 51.9589 30.0751 48.7938 32.5738 46.726C34.1472 45.4236 36.1608 44.6177 38.233 44.4602C39.8718 44.3359 41.474 44.7933 43.0825 45.1195C44.5254 45.4124 46.198 46.2939 47.3406 47.1881C48.439 48.0476 50.0925 49.8064 47.0636 50.8947C46.6262 51.0518 46.7215 50.711 46.3108 50.9247C45.0525 51.5793 44.6991 53.1072 44.1334 54.3682C42.8343 57.2652 39.9825 59.1959 37.2658 60.9739C35.8921 61.8728 34.2006 62.8105 32.6877 62.0663Z",
    fill: "#1E293B",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8858 50.1483C48.1111 51.4234 47.8776 53.34 47.9775 54.5854C48.0819 55.8888 48.514 57.1669 49.2267 58.2816C48.7939 58.463 48.3607 58.6443 47.9279 58.826C47.8006 60.0235 47.6157 61.3361 46.6847 62.144C46.2846 62.4912 45.7804 62.7089 45.2681 62.8721C43.8178 63.3335 42.2301 63.3908 40.7063 63.0655C40.5153 64.1397 40.3976 65.2261 40.354 66.3151C37.4952 66.1436 34.6673 65.5032 32.0308 64.43C32.3827 63.6409 32.5908 62.7928 32.6432 61.936C35.0555 62.2815 37.3739 61.4035 38.7257 58.6797C38.3499 58.9072 37.0205 58.2755 36.6844 57.5549C36.0298 56.1507 36.9435 53.2719 39.3403 54.0501C40.3708 54.3848 40.4728 55.4341 40.694 55.5851C40.7963 55.6549 40.9351 55.638 41.0593 55.6178C41.3349 55.573 41.6109 55.5285 41.8865 55.4837C42.036 55.4594 42.1935 55.4318 42.3095 55.3381C42.6442 55.0671 42.3862 54.5605 42.3369 54.1432C42.2775 53.6416 42.5785 53.1559 42.9701 52.8189C43.3622 52.4818 43.8424 52.2576 44.2879 51.9883C45.1004 51.4969 46.2213 50.8197 46.8858 50.1483Z",
    fill: "white",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7266 54.9968C38.4306 55.0733 38.1444 55.2156 37.9524 55.4444C37.7604 55.6736 37.6782 55.9986 37.7924 56.2709",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2329 62.083C38.614 62.4935 39.1808 62.6921 39.731 62.8465C40.2032 62.9786 40.6849 63.0905 41.1761 63.1181",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2989 74.0464C42.7985 71.3796 41.9913 68.318 41.8689 65.6107C37.8158 64.7226 34.7608 64.1759 30.7073 63.2877C28.5823 65.4661 26.4345 67.6742 24.9346 70.2871C23.8693 72.143 23.1548 74.1627 22.5083 76.1884C19.6083 85.2746 17.9685 94.7298 17.6465 104.227C17.6278 104.778 17.625 105.369 17.9471 105.826C18.2252 106.221 18.6967 106.441 19.1485 106.639C23.2684 108.443 27.6925 109.798 32.2216 109.805C36.7512 109.812 41.414 108.343 44.5277 105.19C44.124 100.8 43.4005 96.437 42.3643 92.1436C41.5588 88.8073 40.5586 85.4667 40.5659 82.0422C40.5719 79.3126 41.794 76.7415 42.2989 74.0464Z",
    fill: "#37B38B",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6099 65.611C33.7097 67.0222 41.5108 68.0479 42.1647 68.5562",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4913 75.7963C32.236 74.234 32.653 72.5875 33.3931 71.1742C34.1332 69.7609 36.5842 68.5974 38.2335 68.5744C39.8764 68.5515 41.3524 69.6537 42.2026 71.0016C43.0527 72.3495 43.3994 73.9246 43.77 75.4593C45.004 80.5695 46.6488 85.5886 48.7109 90.3368C55.8833 90.6897 63.0554 91.0426 70.2278 91.3955C70.6881 94.332 70.751 96.9692 70.4117 99.9208C53.2882 99.9208 40.5635 101.189 38.7257 96.9958C36.5029 91.9251 34.4588 87.8338 32.4913 75.7963Z",
    fill: "#37B38B",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.601 99.9701C72.4235 99.6196 72.3272 98.5892 73.4631 98.542C79.6729 98.2852 87.7729 97.692 93.9827 97.4348C94.6423 97.4075 95.5662 97.6367 95.4727 98.2636C95.402 98.7385 94.779 98.9172 94.2791 98.9394C87.2216 99.2529 81.2199 99.5872 72.6007 99.9701H72.601Z",
    fill: "white",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5613 157.284C49.26 159.243 48.9583 161.202 48.657 163.161C48.6409 163.267 48.6254 163.379 48.6693 163.477C48.7622 163.684 49.0491 163.715 49.2836 163.716C55.216 163.726 61.1483 163.737 67.0807 163.747C67.2727 163.182 67.0051 162.551 66.5825 162.116C66.1599 161.681 65.6016 161.396 65.0731 161.085C63.8 160.336 62.6472 159.399 61.6676 158.318C61.3516 157.969 61.0369 157.593 60.597 157.404C60.2581 157.258 59.8773 157.239 59.5064 157.222C56.4926 157.087 53.477 156.994 49.5613 157.285V157.284Z",
    fill: "white",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.169 104.961C17.9844 107.4 18.1187 109.904 19.0083 112.195C19.8978 114.487 21.6146 116.555 23.9506 117.536C25.3393 118.12 26.8638 118.389 28.3785 118.452C38.6977 118.876 47.9913 118.951 56.452 118.663C52.8833 131.734 49.5917 144.874 47.0314 158.031C53 158.445 58.9824 158.672 64.5892 158.647C68.0928 145.239 70.1411 131.521 71.7296 117.783C72.186 113.835 72.3773 109.258 69.3487 106.548C67.186 104.613 64.0041 104.252 61.0539 104.05C55.484 103.668 50.5945 104.009 45.0523 104.009C35.7247 104.009 27.4587 104.489 18.1694 104.961L18.169 104.961Z",
    fill: "#2473BD",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0523 98.2342C95.6499 90.4849 96.8499 86.55 98.4475 78.8006C98.4813 78.6361 98.5228 78.4592 98.6557 78.35C98.8937 78.1541 99.2931 78.3112 99.439 78.5772C99.5849 78.8431 99.5526 79.163 99.515 79.4613C98.778 85.311 96.0469 95.9817 95.6615 97.7725C95.5722 98.1871 95.4513 98.6472 95.0768 98.8716C94.7024 99.0961 93.9377 98.7924 94.0527 98.2346L94.0523 98.2342Z",
    fill: "white",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3817 120.872C11.5568 102.249 9.14169 93.0426 9.58891 90.1907C9.66732 89.6919 9.88812 89.1256 10.3944 88.9878C11.0181 88.8179 11.5687 89.4074 11.8848 89.9501C12.6235 91.2201 13.082 92.6182 13.5527 94.0005C16.5258 102.733 19.1894 110.942 23.4743 119.158C21.7631 119.158 20.496 120.145 20.3821 120.872H20.3817Z",
    fill: "white",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.8418 100.029C36.2096 99.3506 67.2357 100.908 99.5465 98.9458",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.59177 99.9702C5.52856 113.079 2.49644 146.4 0.347168 163.697",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0518 99.295C100.162 110.05 109.281 138.276 116.449 163.062",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.332 162.67C123.811 156.59 128.161 150.97 133.222 146.016C135.107 144.172 137.174 142.37 139.729 141.554C140.532 141.297 141.472 141.161 142.179 141.606C143.009 142.129 143.173 143.217 143.188 144.169C143.292 150.747 140.098 156.908 136.981 162.769C130.987 163.405 124.941 163.585 120.332 162.67Z",
    fill: "#7DC97F",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.624 142.499C136.102 149.288 131.58 156.077 127.058 162.866",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.727 163.05C109.47 157.766 111.268 152.079 113.805 146.702C116.343 141.326 119.779 136.11 124.914 132.854C125.981 132.177 127.452 131.606 128.464 132.358C128.916 132.694 129.156 133.227 129.332 133.749C130.291 136.595 129.872 139.69 129.217 142.614C127.662 149.556 124.844 156.199 123.407 163.164C117.199 163.164 114.764 163.049 106.727 163.049L106.727 163.05Z",
    fill: "#7DC97F",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.727 133.859C122.053 143.308 117.842 152.968 114.113 162.795",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.005 122.94C143.603 123.061 143.403 123.571 143.598 123.929C143.793 124.287 144.312 124.43 144.689 124.249C145.063 124.071 145.258 123.593 145.08 123.231C144.902 122.868 144.409 122.818 144.006 122.94L144.005 122.94Z",
    fill: "#1E293B",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2651 53.5545C16.8633 53.6755 16.6632 54.1858 16.858 54.5438C17.0528 54.9017 17.5717 55.0443 17.949 54.864C18.3231 54.6853 18.5178 54.2074 18.3396 53.845C18.1613 53.4827 17.6687 53.4328 17.2655 53.5542L17.2651 53.5545Z",
    fill: "#1E293B",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.192 147.265C216.509 147.271 215.851 147.771 215.737 148.417C215.624 149.063 216.114 149.764 216.789 149.868C217.502 149.976 218.219 149.392 218.299 148.705C218.38 148.017 217.884 147.331 217.192 147.265Z",
    fill: "#1E293B",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8335 0.25293C22.1865 0.963792 22.5398 1.67499 22.8928 2.38586L21.8335 0.25293Z",
    fill: "#1E293B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4268 9.5625C14.7798 10.2734 15.1331 10.9846 15.4861 11.6954",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.65771 83.1301C3.68505 82.458 4.7124 81.7859 5.73975 81.1141C5.59525 81.346 5.45074 81.5779 2.65771 83.1301Z",
    fill: "#1E293B",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.591 123.94C200.563 123.268 199.536 122.596 198.509 121.924C198.653 122.156 198.798 122.388 201.591 123.94Z",
    fill: "#1E293B",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.75 72.4519C201.765 72.9888 202.781 73.5258 203.797 74.0627C203.895 74.115 204.01 74.2023 203.977 74.3054C203.943 74.4085 203.737 74.2774 200.75 72.4519Z",
    fill: "#1E293B",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.812 96.0723C115.362 96.6314 115.002 97.2567 114.749 97.9194L115.812 96.0723Z",
    fill: "#1E293B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.362 143.44C170.913 143.999 170.553 144.624 170.299 145.287",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.663 51.1602C116.113 51.1602 122.963 44.7382 122.963 36.8162C122.963 28.8942 116.113 22.4722 107.663 22.4722C99.213 22.4722 92.3628 28.8942 92.3628 36.8162C92.3628 44.7382 99.213 51.1602 107.663 51.1602Z",
    fill: "white",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.854 48.7216C106.905 48.7431 104.942 48.5663 103.075 48.0464C100.187 47.2423 97.5479 45.581 95.8533 43.2685C94.1587 40.956 93.4667 37.9871 94.1878 35.2721C94.9774 32.299 96.4558 29.5137 99.0818 27.6567C100.818 26.4287 103.056 25.6633 105.371 25.3185C105.066 23.2539 104.76 21.1898 104.455 19.1252C100.811 19.6317 97.2754 20.8193 94.5474 22.7487C90.5293 25.5905 88.2671 29.8526 87.0583 34.4019C85.9549 38.5563 87.0138 43.0992 89.6071 46.6381C92.2003 50.177 96.2388 52.719 100.658 53.9496C103.515 54.7448 106.519 55.0155 109.501 54.9827C111.616 54.9591 113.749 54.773 115.791 54.2863C115.091 52.2142 114.391 50.1421 113.692 48.0699C112.141 48.5372 110.489 48.7031 108.854 48.7212L108.854 48.7216Z",
    fill: "#2473BD",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.296 47.677C114.003 47.7894 113.703 47.8853 113.401 47.9739C114.102 49.9923 114.804 52.0107 115.505 54.0291C116.352 53.8331 117.185 53.5919 117.991 53.2827C123.791 51.0626 127.447 45.7181 128.223 40.0492C125.766 40.0156 123.311 39.8967 120.865 39.6851C120.18 43.1399 117.861 46.3123 114.296 47.677Z",
    fill: "#1E293B",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.997 32.5863C125.573 24.6986 117.886 19.7332 112.764 18.959C110.105 18.5572 107.178 18.5387 104.316 18.9321C104.624 20.9912 104.932 23.0498 105.24 25.1088C107.169 24.8246 109.151 24.8254 110.947 25.0966C114.294 25.6026 119.318 28.8473 120.901 34.0016C121.428 35.716 121.485 37.5495 121.141 39.3121C123.602 39.5288 126.072 39.6506 128.544 39.685C128.864 37.3085 128.701 34.8775 127.997 32.5863Z",
    fill: "#37B38B",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.736 84.3493C160.736 85.4075 160.777 87.4984 160.777 87.4984C160.777 87.4984 176.833 87.4227 196.096 87.1255C196.263 85.9748 196.429 84.8241 196.596 83.6733C181.574 83.8983 176.117 83.8907 160.736 84.3493Z",
    fill: "white",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.617 84.0355C196.45 85.0304 196.284 86.0254 196.118 87.0203C200.049 86.9676 213.319 86.685 216.442 86.6386C216.69 85.3053 216.799 84.7961 216.481 83.6733C213.063 83.7158 200.038 83.9915 196.617 84.0355Z",
    fill: "#37B38B",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.736 93.516C160.736 94.4862 160.777 96.5401 160.777 96.5401C160.777 96.5401 168.388 96.691 185.093 96.4272C185.262 95.3635 185.43 94.2998 185.599 93.2361C174.312 93.4097 172.259 93.2026 160.736 93.516Z",
    fill: "#2473BD",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.622 93.4649C185.455 94.5042 185.288 95.5436 185.121 96.583C193.191 96.4574 210.431 95.9229 216.443 95.8304C216.69 94.4489 216.799 93.9213 216.482 92.7579C209.277 92.8517 192.855 93.3554 185.623 93.4653L185.622 93.4649Z",
    fill: "white",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.442 76.4109C216.69 74.9466 216.799 74.3875 216.481 73.1544C203.377 73.3338 190.269 73.5153 176.999 73.7966C176.838 74.8576 176.676 75.9185 176.514 76.9795C188.904 76.8151 205.806 76.5843 216.442 76.4113V76.4109Z",
    fill: "#2473BD",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.778 77.4577C160.778 77.4577 167.432 77.3739 176.507 77.2551C176.669 76.2069 176.831 75.1588 176.992 74.1107C171.604 74.2237 166.191 74.351 160.736 74.5032C160.736 75.4964 160.777 77.4572 160.777 77.4572L160.778 77.4577Z",
    fill: "#1E293B",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.739 56.8979L151.565 16.7346H213.809L211.983 56.8979H149.739Z",
    fill: "white",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.433 42.5538C161.274 38.077 166.268 33.7301 171.677 29.8133C177.326 32.5192 191.479 39.0282 191.479 39.0282C191.479 39.0282 199.728 29.3279 205.202 24.8628",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.943 24.3848C201.832 24.3957 203.721 24.4067 205.61 24.4176C205.711 25.9988 205.703 27.5858 205.589 29.1661",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.509 44.755L157.389 52.1165L160.667 51.887L160.736 44.4663L157.509 44.755Z",
    fill: "#2473BD",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.249 42.3623L190.858 52.1165L193.862 51.8884L194.205 42.0757L191.249 42.3623Z",
    fill: "#2473BD",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.777 35.6758L168.386 52.1165H171.389L171.733 35.3818L168.777 35.6758Z",
    fill: "#2473BD",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.4 31.3651L201.855 52.1165H205.188L205.681 31.0786L202.4 31.3651Z",
    fill: "#2473BD",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.65 39.4991L179.383 52.1165H182.998L183.208 39.2069L179.65 39.4991Z",
    fill: "#2473BD",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.287 46.2682C199.652 43.7166 197.423 41.6134 194.787 39.0615C194.383 38.6695 193.466 37.9755 193.017 38.5185C192.698 38.9051 193.256 40.3164 195.464 42.1348C193.258 40.1273 192.215 39.2728 190.009 37.2649C189.73 37.0111 189.379 36.7374 189.041 36.8372C188.695 36.9397 188.578 37.4082 188.704 37.7739C188.83 38.1396 189.123 38.4217 189.405 38.6863C191.022 40.2034 190.999 40.4431 192.616 41.9602C190.559 39.9517 190.42 39.6382 188.144 37.9094C187.767 37.6232 187.251 37.3334 186.898 37.598C186.146 38.3338 187.668 39.5897 188.831 40.5904C189.497 41.1637 190.138 41.702 191.761 43.0091C190.092 41.7654 189.475 41.1725 187.803 39.9331C187.489 39.7002 187.151 39.4582 186.777 39.4353C186.404 39.4124 186.012 39.7191 186.086 40.1023C186.134 40.3464 186.342 40.5274 186.535 40.6851C188.326 42.1459 188.852 42.8207 190.642 44.2815C189.327 43.2397 189.184 43.1146 187.711 42.3532C187.274 42.127 186.634 41.9723 186.438 42.4051C186.258 42.8049 186.674 43.2501 187.04 43.5292C190.639 46.2766 193.466 48.0546 197.065 50.802",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.287 46.4578C199.652 43.9062 197.423 41.8029 194.787 39.251C194.383 38.859 193.466 38.165 193.017 38.708C192.698 39.0947 193.256 40.5059 195.464 42.3244C193.258 40.3168 192.215 39.4624 190.009 37.4545C189.73 37.2007 189.379 36.927 189.041 37.0268C188.695 37.1292 188.578 37.5978 188.704 37.9635C188.83 38.3292 189.123 38.6113 189.405 38.8759C191.022 40.393 190.999 40.6327 192.616 42.1498C190.559 40.1412 190.42 39.8278 188.144 38.099C187.767 37.8128 187.251 37.5229 186.898 37.7875C186.146 38.5233 187.668 39.7792 188.831 40.78C189.497 41.3533 190.138 41.8916 191.761 43.1987C190.092 41.955 189.475 41.3621 187.803 40.1227C187.489 39.8898 187.151 39.6478 186.777 39.6249C186.404 39.6019 186.012 39.9087 186.086 40.2919C186.134 40.5359 186.342 40.7169 186.535 40.8747C188.326 42.3355 188.852 43.0103 190.642 44.4711C189.327 43.4293 189.184 43.3042 187.711 42.5428C187.274 42.3166 186.634 42.1619 186.438 42.5947C186.258 42.9945 186.674 43.4397 187.04 43.7188C190.639 46.4662 193.466 48.2442 197.065 50.9916",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4678 41.1945C98.1219 41.8224 97.8318 42.4884 97.7274 43.1912C97.623 43.894 97.7162 44.6402 98.0945 45.2507",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.943 127.449C274.78 136.42 278.963 149.364 281.728 156.572C284.271 156.927 286.968 156.052 288.763 154.289C288.58 151.295 284.666 121.038 282.069 114.62C281.006 111.994 279.478 109.444 277.119 107.765C276.006 106.973 274.558 106.265 273.252 106.71C268.894 108.194 267.951 117.043 271.943 127.449Z",
    fill: "white",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253 130.889C252.72 138.656 253.857 150.462 254.246 158.225C254.258 158.469 254.181 158.805 253.926 158.796C256.127 159.169 258.419 159.046 260.563 158.439C260.874 158.351 261.208 158.235 261.379 157.97C261.5 157.782 261.517 157.551 261.531 157.33C261.901 151.357 263.715 141.182 263.655 135.199C263.633 133.091 263.543 130.917 262.626 129.001C261.71 127.085 259.767 125.471 257.568 125.515C256.064 125.546 254.645 126.356 253.718 127.492C252.79 128.628 252.316 130.058 253 130.889Z",
    fill: "white",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.591 157.696C251.649 159.561 249.704 160.859 247.15 161.833C246.628 162.033 246.087 162.216 245.648 162.552C245.209 162.888 244.884 163.418 244.971 163.95C246.967 164.048 257.732 164.266 262.497 163.95C262.334 161.988 262.171 159.234 262.008 157.272C259.068 157.491 256.112 157.517 253.591 157.696Z",
    fill: "#1E293B",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.542 156.687C281.216 157.559 280.89 158.432 280.564 159.304C280.459 159.584 280.351 159.871 280.151 160.099C279.899 160.388 279.529 160.552 279.171 160.707C278.198 161.131 277.224 161.554 276.25 161.977C275.979 162.095 275.691 162.227 275.539 162.473C275.274 162.9 275.572 163.484 276.025 163.726C276.478 163.968 277.026 163.96 277.544 163.943C279.303 163.884 281.06 163.781 282.813 163.636C283.6 163.571 284.394 163.495 285.142 163.255C287.599 162.464 289.104 160.089 291.337 158.828C290.695 157.145 289.908 155.512 288.988 153.952C286.451 155.123 283.776 156.021 281.542 156.687Z",
    fill: "#1E293B",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.279 76.477C246.279 94.3794 247.226 115.485 246.079 134.93C257.368 135.283 265.97 134.546 277.578 132.868C277.947 125.527 278.032 118.173 277.834 110.825C278.558 114.745 280.695 118.282 281.935 122.081C282.577 124.049 282.978 126.081 283.576 128.061C284.121 129.863 284.828 131.614 285.682 133.259C289.741 132.893 293.772 132.242 297.809 130.854C290.6 111.719 283.93 92.3971 277.842 72.8691C269.835 75.5161 261.271 76.6021 252.822 76.0416C250.275 75.8727 247.642 75.5656 246.279 76.477H246.279Z",
    fill: "#1E293B",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.869 38.1138C242.489 36.5312 243.472 34.969 243.741 33.3656C244.11 31.1737 243.134 28.8564 243.85 26.745C244.106 25.9927 244.565 25.3135 244.8 24.5551C245.177 23.3414 244.953 22.0329 245.149 20.7804C245.509 18.4779 247.29 16.5496 249.413 15.4174C251.535 14.2852 253.975 13.8403 256.384 13.5386C257.407 13.4105 258.45 13.3057 259.466 13.4776C261.078 13.7499 262.501 14.7109 263.545 15.9193C264.589 17.1276 265.29 18.5736 265.87 20.0412C266.355 21.2694 266.8 22.5809 267.805 23.4725C268.946 24.4833 270.651 24.8029 271.669 25.9276C272.689 27.0548 272.762 28.6966 273.456 30.032C274.137 31.3415 275.384 32.2994 276.19 33.5418C276.801 34.4833 277.147 35.5814 277.18 36.6893C277.209 37.654 276.893 38.7646 275.974 39.158C275.6 39.3181 275.179 39.3336 274.77 39.3582C272.056 39.522 269.378 40.2093 266.942 41.3671C266.543 41.5568 266.136 41.7628 265.692 41.7931C264.953 41.8433 264.29 41.4058 263.618 41.1092C260.874 39.9005 257.696 40.9936 254.682 41.1776C251.925 41.3458 249.17 40.727 246.41 40.8332C245.412 40.8716 244.35 40.9926 243.468 40.5433C242.586 40.094 242.13 38.7768 242.869 38.1134L242.869 38.1138Z",
    fill: "#1E293B",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.581 43.0058C207.252 47.9838 214.592 52.5598 221.861 56.6975C227.193 52.3218 232.183 47.9457 237.516 43.57C240.636 41.0093 243.908 38.3715 247.888 37.3981C251.335 36.5551 254.973 37.0499 258.515 36.7324C261.157 36.4957 263.741 35.8065 266.387 35.6029C269.032 35.3993 271.873 35.7495 273.943 37.3424C275.193 38.3044 276.06 39.6382 276.903 40.9453C280.122 45.9358 283.34 50.9264 286.558 55.9172C288.222 58.4978 289.932 61.6779 288.542 64.4034C287.799 65.8616 286.305 66.8215 284.811 67.586C282.64 68.6976 280.323 69.5473 277.932 70.1089C278.131 71.8164 278.33 73.524 278.529 75.2315C267.849 77.3493 256.893 78.1876 245.997 77.7207C246.02 75.9545 243.952 61.4582 242.574 56.0645C241.653 57.0926 240.564 57.9683 239.481 58.8389C235.589 61.9655 231.698 65.092 227.808 68.219C226.934 68.9207 226.039 69.6353 224.971 70.0162C223.44 70.5619 221.728 70.3593 220.153 69.944C215.567 68.735 211.681 65.8663 208.001 62.9793C203.374 59.3502 198.862 55.5876 194.472 51.6982C196.341 48.9515 198.21 46.2045 200.582 43.0058H200.581Z",
    fill: "#2473BD",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.975 17.8668C247.714 20.4258 247.033 23.2453 246.991 26.0749C246.975 27.2054 247.068 28.3707 247.587 29.3859C248.467 31.1069 250.618 32.1363 252.582 31.776C252.673 33.317 252.975 34.847 253.477 36.3135C252.511 36.6044 251.519 36.8181 250.516 36.9512C252.685 40.5952 255.645 43.8051 259.151 46.3165C261.279 42.922 263.126 39.3656 264.669 35.6916C263.693 35.8086 262.717 35.9252 261.927 36.0354C261.784 34.6687 261.128 33.3565 260.108 32.3922C259.457 31.7774 258.669 31.3034 258.053 30.657C257.263 29.8288 256.79 28.729 256.741 27.6079C257.757 27.6692 258.84 27.2017 259.298 26.3298C259.756 25.4578 259.401 24.2231 258.462 23.8443C257.524 23.4654 256.261 24.2683 256.404 25.235C252.894 24.4803 249.959 21.6736 248.975 17.8668Z",
    fill: "white",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.1 23.1941C248.83 24.2966 248.459 25.3762 247.992 26.4164C248.494 26.5421 248.997 26.6678 249.5 26.7936",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.1 23.1941C248.83 24.2966 248.459 25.3762 247.992 26.4164C248.494 26.5421 248.997 26.6678 249.5 26.7936",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.888 56.9636C246.045 57.3351 238.651 58.5084 233.957 59.7076C237.211 65.4862 239.803 71.6076 241.669 77.9262C246.41 77.7081 253.705 76.4751 258.203 75.022C257.174 73.0903 252.745 61.2568 250.888 56.9636Z",
    fill: "white",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.967 76.728C255.734 72.5282 254.392 68.2951 252.148 64.4991C250.945 62.4636 243.098 59.6784 242.003 59.9569C238.671 60.8042 236.785 61.2603 233.586 62.4905C236.732 68.3504 238.62 73.169 240.173 79.589C243.066 79.8074 253.75 77.8332 256.967 76.728H256.967Z",
    fill: "white",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.867 60.016C245.424 62.0465 244.434 63.5949 243.586 64.4888C246.492 64.3034 249.016 64.5414 251.826 64.4551",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.076 71.1465C257.157 72.4222 254.04 73.7054 250.793 74.0159C249.865 74.1049 249.969 73.2774 250.487 73.0323C251.584 72.5136 252.637 72.0818 253.565 71.6366C252.246 72.3248 250.919 72.9427 249.406 73.1149C249.162 73.1429 248.906 73.155 248.682 73.0798C248.458 73.0043 248.273 72.8203 248.293 72.6123C248.32 72.3447 248.642 72.1694 248.927 72.0417C250.339 71.4084 251.723 70.889 253.121 70.3079C252.185 70.7508 251.278 71.0804 250.312 71.4697C249.594 71.7592 248.855 72.0366 248.077 72.1297C247.856 72.156 247.627 72.1668 247.42 72.1081C247.212 72.0495 247.03 71.9086 246.996 71.7245C246.933 71.3827 247.36 71.1155 247.729 70.9479C249.367 70.2037 251.015 69.6378 252.656 69.0884C251.293 69.6934 249.909 70.0948 248.442 70.4565C248.135 70.532 247.382 70.6921 247.222 70.468C247.127 70.3341 247.168 70.1505 247.275 70.0153C247.383 69.8801 247.544 69.7831 247.704 69.692C248.823 69.0533 249.766 68.5828 250.965 68.0664C251.51 67.8321 253.257 67.2632 254.851 66.9726L254.564 65.8573C254.564 65.8573 259.839 66.1202 260.211 66.1485",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.076 71.1465C257.157 72.4222 254.04 73.7054 250.793 74.0159C249.865 74.1049 249.969 73.2774 250.487 73.0323C251.584 72.5136 252.637 72.0818 253.565 71.6366C252.246 72.3248 250.919 72.9427 249.406 73.1149C249.162 73.1429 248.906 73.155 248.682 73.0798C248.458 73.0043 248.273 72.8203 248.293 72.6123C248.32 72.3447 248.642 72.1694 248.927 72.0417C250.339 71.4084 251.723 70.889 253.121 70.3079C252.185 70.7508 251.278 71.0804 250.312 71.4697C249.594 71.7592 248.855 72.0366 248.077 72.1297C247.856 72.156 247.627 72.1668 247.42 72.1081C247.212 72.0495 247.03 71.9086 246.996 71.7245C246.933 71.3827 247.36 71.1155 247.729 70.9479C249.367 70.2037 251.015 69.6378 252.656 69.0884C251.293 69.6934 249.909 70.0948 248.442 70.4565C248.135 70.532 247.382 70.6921 247.222 70.468C247.127 70.3341 247.168 70.1505 247.275 70.0153C247.383 69.8801 247.544 69.7831 247.704 69.692C248.823 69.0533 249.766 68.5828 250.965 68.0664C251.51 67.8321 253.257 67.2632 254.851 66.9726L254.564 65.8573C254.564 65.8573 259.839 66.1202 260.211 66.1485",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.939 49.8739C271.854 53.0544 273.645 56.3037 275.344 59.5772C270.535 60.9218 264.65 63.0291 259.84 64.3736C259.99 67.3819 261.414 70.7434 262.708 73.4878C267.949 72.8719 273.115 71.8493 278.063 70.0777",
    fill: "#2473BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.939 49.8739C271.854 53.0544 273.645 56.3037 275.344 59.5772C270.535 60.9218 264.65 63.0291 259.84 64.3736C259.99 67.3819 261.414 70.7434 262.708 73.4878C267.949 72.8719 273.115 71.8493 278.063 70.0777",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0408 79.8581C84.0644 80.2595 83.1728 80.9212 82.6855 81.8262C82.1978 82.7312 82.1739 83.895 82.7766 84.734C83.3043 85.4685 84.2181 85.8645 85.1262 86.057C86.4549 86.3387 88.0655 86.15 88.8232 85.0663C89.4417 84.1819 89.2848 82.9803 88.8302 82.0092C88.4681 81.2353 87.9189 80.5227 87.1707 80.0697C86.4225 79.6167 85.5903 79.6322 85.0408 79.8584V79.8581Z",
    fill: "white",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0054 80.8749C91.3058 77.2869 94.6258 74.0707 97.9262 70.4827",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8158 70.2213C98.6459 72.6384 102.844 71.9255 103.332 69.6163C103.581 68.4335 103.06 67.0441 101.646 66.6562C97.9772 65.6494 97.3229 68.7857 97.8158 70.2213Z",
    fill: "#2473BD",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.331 69.9718C107.325 71.8759 111.373 73.6775 115.467 75.3746",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.081 74.9477C115.821 75.3957 115.709 75.9127 115.858 76.4048C116.227 77.6155 117.623 78.4788 118.909 78.2128C120.195 77.9469 120.975 76.3789 120.548 75.1863C120.121 73.9938 117.499 72.5043 116.081 74.948L116.081 74.9477Z",
    fill: "#1E293B",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.029 75.8273C122.226 74.1662 124.423 72.5052 126.62 70.8445",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.729 67.0066C126.313 66.1697 125.146 68.9724 126.341 70.2428C126.942 70.8822 127.83 71.3308 128.715 71.1825C129.599 71.0342 130.361 70.2482 130.322 69.388C130.279 68.4546 129.723 67.3514 128.728 67.007L128.729 67.0066Z",
    fill: "white",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3096 75.6241C87.7938 75.5584 96.7449 75.4778 101.229 75.4121L83.3096 75.6241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.196 82.9543C118.68 82.8886 127.632 82.808 132.116 82.7423",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3096 80.8149C85.6508 80.8652 92.4594 80.9012 94.8006 80.9518L83.3096 80.8149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.196 88.1451C116.538 88.1954 123.346 88.2314 125.687 88.282",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.659 81.9746C109.53 82.097 108.492 81.9294 107.386 82.0494C107.411 82.9764 107.448 84.6967 107.448 84.6967C107.448 84.6967 109.725 84.6175 110.768 84.4827C110.768 83.6956 110.756 83.2777 110.659 81.9746Z",
    fill: "white",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.957 87.2197C109.828 87.3421 108.79 87.1746 107.684 87.2946C107.709 88.2215 107.746 89.9418 107.746 89.9418C107.746 89.9418 110.022 89.8626 111.066 89.7278C111.066 88.9408 111.054 88.5228 110.957 87.2197Z",
    fill: "white",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9919 30.6815L47.2884 30.8375C47.2884 30.8375 47.2223 24.5881 46.9399 20.4186C58.611 20.6411 79.9293 20.0815 79.9293 20.0815L79.9919 30.6815Z",
    fill: "#2473BD",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1938 27.8171C53.1336 26.0765 54.7946 24.7057 56.7297 24.0737C58.6652 23.4417 60.8535 23.5549 62.7064 24.3838C63.9092 24.9217 64.9527 25.7357 66.1056 26.3664C67.1554 26.9407 68.3726 27.3691 69.5592 27.1484C71.0131 26.878 72.0816 25.7145 72.9735 24.5816",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5438 23.0889C73.1609 23.0691 72.7678 23.2163 72.5157 23.4934C72.2637 23.7705 72.1652 24.1743 72.2826 24.5241C72.4563 25.0415 73.0473 25.3446 73.6138 25.3739C73.9211 25.3897 74.2547 25.3294 74.4653 25.114C74.6935 24.8808 74.7206 24.5258 74.6756 24.2093C74.6007 23.6808 74.2252 23.1243 73.5438 23.0889Z",
    fill: "white",
    stroke: "#1E293B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3310_35193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 298.834,
    height: 164,
    fill: "white",
    transform: "translate(0.0830078)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneMarket);
export default __webpack_public_path__ + "static/media/ONEMarket.a8d83a68abaa28255020ebaddbc5a492.svg";
export { ForwardRef as ReactComponent };